$('.no-js').removeClass('no-js').addClass('js');

var template_path = $('html').data('path');

// SVG-Unterstützung für IE laden.
svg4everybody();

function setCookie(cname, cvalue, exdays = 0) {
  var date, expires;
  if (exdays) {
    date = new Date();
    date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
    expires = ' expires=' + date.toGMTString();
  }
  document.cookie = cname + '=' + cvalue + '; path=/;' + expires;
}

function hasCookieVal(cname, val) {
  if (document.cookie.indexOf(cname+'='+val) >= 0) {
    return true;
  }
  return false;
}

function hasCookie(cname) {
  if(hasCookieVal(cname, 'true')) {
    return true;
  }
  return false;
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function hasCookieSplitVal(cname, val) {
  var value = getCookie(cname);
  var split = value.split('|');
  for(var i = 0; i <split.length; i++) {
    var c = split[i];
    if (c.indexOf(val) == 0) {
      return true;
    }
  }
  return false;
}

function addCookieSplitVal(cname, val, exdays = 0) {
  var newval;
  var value = getCookie(cname);
  if (value) {
    var split = value.split('|');
    for(var i = 0; i <split.length; i++) {
      var c = split[i];
      if (c==val) {
        return false;
      }
    }
    split.push(val);
    newval = split.join('|');
  } else {
    newval = val;
  }
  setCookie(cname, newval, exdays);
}

function removeCookieSplitVal(cname, val, exdays = 0) {
  var value = getCookie(cname);
  var split = value.split('|');
  var filtered = split.filter(function(value, index, arr){ return value != val;});
  var newval = filtered.join('|');
  setCookie(cname, newval, exdays);
}

function removeCookie(cname) {
  document.cookie = cname + '= ;  path=/; expires = Thu, 01 Jan 1970 00:00:00 GMT';
}

/**
 * Add hash to url without scrolling
 *
 * @param String $url - it could be hash or url with hash
 *
 * @return void
 */
function addHashToUrl($url) {
  if ('' == $url || undefined == $url) {
    $url = '_'; // it is empty hash because if put empty string here then browser will scroll to top of page
  }
  $hash = $url.replace(/^.*#/, '');
  var $fx, $node = jQuery('#' + $hash);
  if ($node.length) {
    $fx = jQuery('<div></div>')
      .css({
        position: 'absolute',
        visibility: 'hidden',
        top: jQuery(window).scrollTop() + 'px'
      })
      .attr('id', $hash)
      .appendTo(document.body);
    $node.attr('id', '');
  }
  document.location.hash = $hash;
  if ($node.length) {
    $fx.remove();
    $node.attr('id', $hash);
  }
}


// Menü ein-/ausblenden.
$('.toggle').each(function() {

  var toggle_for = $('#' + $(this).data('for'));

  toggle_for.hide();

  $(this).click(function(e) {
    $(this).toggleClass('active');
    toggle_for.slideToggle({
      duration: 'fast',
      step: function() {
        if ($(this).css('display') == 'flex') {
          $(this).css('display', 'block');
        }
      },
      complete: function() {
        if ($(this).css('display') == 'flex') {
          $(this).css('display', 'block');
        }
      }
    })

    $(this).attr('aria-expanded', function(i, attr) {
      return attr === 'false';
    });

    $(this).attr('aria-label', function(i, attr) {
      if (attr === 'Menü öffnen') {
        attr = 'Menü schließen'
      } else if (attr === 'Menü schließen') {
        attr = 'Menü öffnen'
      }
      return attr
    });

  });
});

function count_parents() {
  return $('.current').parents('.active').length;
}


// Menü ein-/ausblenden
$('#main-menu li.has-sub > a').on('click', function(e) {
  e.preventDefault();
  var element = $(this).parent('li');
  if (element.hasClass('open')) {
    element.removeClass('open');
    element.children('a').attr('aria-expanded', false);
    element.children('div').slideUp();
    element.children('ul').slideUp();
  } else { // Falls geschlossen.
    element.addClass('open');
    element.siblings('li').removeClass('open');
    element.children('a').attr('aria-expanded', true);
    element.siblings('li.has-sub').children('a').attr('aria-expanded', false);
    element.siblings('li').children('div').slideUp();
    element.siblings('li').children('ul').slideUp();
    element.children('div').slideDown();
    element.children('ul').slideDown();
  }
});

// Suchfeld öffnen.
$('.meta-nav__item--search button, .search-jump').click(function(e) {
  e.preventDefault();

  $(this).toggleClass('active');

  var search = $('.search--desktop');
  var isOpen = search.hasClass('open');

  // Barrierefreiheit: aria-expanded aktualisieren
  $('.meta-nav__item--search button').attr('aria-expanded', isOpen ? 'false' : 'true');

  if (isOpen) {
    search.removeClass('open').slideUp('fast');
  } else {
    search.addClass('open').slideDown('fast');
    $('.search__input').focus();
  }
});

// Zum Suchfeld springen.
$('.search-jump').click(function(e) {
  e.preventDefault();

  $('.search-box').addClass('open').slideDown('fast');
  $('.field').focus();
});

// Suchfeld schließen.
$('.search-btn--reset').click(function(e) {
  e.preventDefault();
  var $form = $(this).closest('form');
  $form.find('.search__input, input[name="s"]').val('');

  var $desktopSearch = $('.search--desktop');
  if ($desktopSearch.length && $desktopSearch.hasClass('open')) {
    $desktopSearch.removeClass('open').slideUp('fast');
    $('.meta-nav__item--search button')
      .removeClass('active')
      .attr('aria-expanded', 'false')
      .first()
      .focus();
  } else {
    $form.find('.search__input, input[name="s"]').focus();
  }
});

// Suchfeld mit Esc-Taste schließen.
$(document).on('keyup', function(e) {
  if (e.keyCode == 27 && $('.search--desktop').hasClass('open')) {
    $('.search__input').val('');
    $('.search--desktop').removeClass('open').slideUp('fast');
    $('.meta-nav__item--search button')
      .removeClass('active')
      .attr('aria-expanded', 'false')
      .first()
      .focus();
  }
});


$(function() {
  $(window).scroll(function() {
    // Show button for jumping to top when scrolling.
    var scroll = $(window).scrollTop();

    if (scroll > 300) {
      $('.btn-top').show();

    } else {
      $('.btn-top').hide();
    }
    //Add sticky class to body when scrolling
    if (scroll > 150) {
      $('html').addClass('sticky');

    } else {
      $('html').removeClass('sticky');
    }
  });
});

// Google map.
$("a.gmap-overlay").click(function(e) {
  e.preventDefault();
  $(this).parent(".google-map").html("<iframe class=\"gmap-iframe\" src=\"" + $(this).attr("href") + "\"></iframe>");
});

// Tabellen für Mobil
$(document).ready(function() {
  $('#content .wp-block-table table').each(function() { // geht jede Gutenberg-Tabelle der aktuellen Seite durch
    var $table = $(this);
    var $headCells = $table.find('thead tr').first().children();

    if (!$headCells.length) { // ohne Kopfzeile keine Beschriftung möglich
      return;
    }

    $table.closest('.wp-block-table').addClass('is-responsive');

    $table.find('tbody tr').each(function() {
      $(this).children().each(function(index) {
        var tableText = $headCells.eq(index).text();
        $(this).wrapInner('<p></p>').prepend($('<p class="res-thead"></p>').text(tableText));
      });
    });
  });
});
